import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.deviceTypeData ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.description'),
      "icon": "fa-align-left",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.deviceTypeData.description || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)])], 1), _c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.manufacturerInformation'),
      "icon": "fa-industry-alt",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.manufacturerDeviceName')) + ":" + _vm._s(' ') + "\n          " + _vm._s(_vm.deviceName || _vm.$i18n_t('Common.notAvailable')) + "\n          "), _c(VDivider, {
    staticClass: "mt-4 pb-2",
    attrs: {
      "dark": ""
    }
  }), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.manufacturerAttachments')) + "\n          "), _c(VSimpleTable, {
    staticClass: "mt-2 file-table",
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', _vm._l((_vm.deviceTypeData.properties.manufacturer || {}).device_manual_file, function (item) {
    return _c('tr', {
      key: item.id,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.clickManufacturerFile(item);
        }
      }
    }, [_c('td', {
      staticClass: "pt-0 pb-0 pl-2 pr-0 text-truncate",
      staticStyle: {
        "max-width": "1px"
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _c('td', {
      staticClass: "pt-0 pb-0 pl-0 pr-2 text-right",
      staticStyle: {
        "width": "90px"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.readableFileSizeFromBytes(item.size)) + "\n                ")])]);
  }), 0)])], 1)])], 1)], 1), _c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.installationNotes'),
      "icon": "fa-tools",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.deviceTypeData.properties.notes || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)])], 1), _c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.highlights'),
      "icon": "fa-highlighter",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.deviceTypeData.properties.highlights || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)])], 1)], 1), _c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.technicalSpecs'),
      "icon": "fa-wrench",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c(VRow, _vm._l(_vm.techSpecKeys, function (key) {
    return _c(VCol, {
      key: key,
      attrs: {
        "cols": "12",
        "xl": "1",
        "lg": "2",
        "md": "3",
        "sm": "4",
        "xs": "12"
      }
    }, [_c('custom-fields-display-field', {
      attrs: {
        "value": (_vm.deviceTypeData.properties.technical_specs || {})[key] || '-',
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create')[key]
      }
    })], 1);
  }), 1)], 1)])], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };